import { gql } from '@apollo/client';

export default gql`
  query TaxNexusReadiness {
    taxNexusReadiness {
      jurisdiction
      jurisdictionName
      providerConfigured
      orderCount
      refundCount
      netAmountCents
      netSalesTaxCents
      openSyncCount
      blockedSyncCount
      reconciliationHealth
      reviewRequired
      filingReadinessId
      registrationStatus
      registeredOn
      nexusEffectiveOn
      taxIdentifierReference
      assignedFilingFrequency
      externalAutofileStatus
      notes
      reviewedById
      reviewedAt
    }
  }
`;
